var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"table",attrs:{"loadObj":{},"option":{},"colObj":{
      opId:"3144",
      name:"字段映射",
      parentId:"GEN_ID",
      parentName:"数据生成设置",
      parentPath:"/system/genData",
      parentQuery:{
      },
      addForm:{
      },
      dataClass:2,
      col:[]
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }